/* Product-page navigation only. Uses native history so filters, car and scroll
   remain on their original page. No cart requests or vehicle-storage changes. */
(() => {
  'use strict';
  if (window.SenfinecoProductBack) return;
  const selector = '[data-sf26-product-back]';
  const productPath = location.pathname;
  let returning = false, remaining = 0;

  function localURL(value) {
    if (!value) return null;
    try {
      const url = new URL(value, location.origin);
      return /^https?:$/.test(url.protocol) && url.origin === location.origin
        && !url.username && !url.password ? url : null;
    } catch (_) { return null; }
  }
  const referrer = localURL(document.referrer);
  const previous = referrer && referrer.pathname !== productPath ? referrer : null;

  function previewURL(url) {
    const target = new URL(url.href), current = new URL(location.href);
    ['preview_theme_id', '_fd', 'pb'].forEach(key => {
      if (current.searchParams.has(key) && !target.searchParams.has(key)) {
        target.searchParams.set(key, current.searchParams.get(key));
      }
    });
    return target.pathname + target.search + target.hash;
  }
  function fallback(link) {
    return localURL(link.dataset.sf26BackFallback) || new URL('/', location.origin);
  }
  function refresh() {
    returning = false;
    document.querySelectorAll(selector).forEach(link => {
      link.href = previewURL(previous || fallback(link));
      link.removeAttribute('aria-busy');
    });
  }
  function reset() {
    returning = false;
    document.querySelectorAll(selector).forEach(link => link.removeAttribute('aria-busy'));
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.(selector);
    if (!link || event.defaultPrevented || event.button !== 0
      || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (returning) { event.preventDefault(); return; }
    // A direct/external visit or a new tab has no safe store page to go back to.
    // Keep the real link usable, including when JavaScript is disabled.
    if (!previous || history.length <= 1) return;
    event.preventDefault();
    returning = true;
    remaining = 12;
    link.setAttribute('aria-busy', 'true');
    try { history.back(); }
    catch (_) { reset(); location.assign(link.href); }
  });
  // Skip variant/hash entries created inside this product document, not whole
  // product pages. Leaving the document clears this flag before another page runs.
  addEventListener('popstate', () => {
    if (!returning) return;
    if (location.pathname !== productPath) { reset(); return; }
    if (--remaining > 0 && history.length > 1) history.back();
    else { reset(); location.replace(previewURL(previous)); }
  });
  addEventListener('pagehide', reset);
  addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else refresh();
  window.SenfinecoProductBack = { version: '1.0.0' };
})();
